import { FC, ReactNode } from "react";

import { Icon, IconName, Panel } from "capitalrx-components-2.0/lib/general";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

import "./ComparePlansPage.scss";

interface TileProps {
  iconName?: IconName;
  title?: string;
  description?: string;
  children?: ReactNode;
}

export const HeadingTile: FC<TileProps> = ({ iconName, title, description, children }) => {
  return (
    <Panel className="heading-tile" appearance="secondary">
      <Stack spacing="small">
        {iconName && <Icon name={iconName}></Icon>}
        {title && <Semibold>{title}</Semibold>}
        {description && <Body>{description}</Body>}
        {children}
      </Stack>
    </Panel>
  );
};
